import useOffer from '@/hooks/use-offer/use-offer';
import useSelectedCategory from '@/hooks/use-selected-category/use-selected-category';

const useSelectedOffer = () => {
  const selectedCategory = useSelectedCategory();
  return useOffer(selectedCategory);
};

export default useSelectedOffer;
